import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'

import { useFindOperationPosts } from '@hooks/catalogs/operationPosts'
import { useFindPermits } from '@hooks/catalogs/permitTypes'
import { useDate } from '@hooks/dates'
import { useFindTask } from '@hooks/task/find'

import { TaskPills } from '../Pills'
import { BoldText, LabelValueHeader, RegularText } from './styles'

export function DownstreamData() {
  const { taskId } = useParams<{ taskId: string }>()

  const { formatDate } = useDate()

  const { data: rawTask } = useFindTask(Number(taskId))
  const { data: rawOperationPosts } = useFindOperationPosts()
  const { data: rawPermitTypes } = useFindPermits()

  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)
  const operationPosts = rawOperationPosts ?? []
  const permitTypes = rawPermitTypes ?? []

  const permitOptions = [
    { label: 'No', value: 0 },
    { label: 'Yes', value: 1 },
    { label: 'Unspecified', value: 2 },
  ]

  const getPermitResults = (param: number) =>
    permitOptions.find((p) => p.value === param)

  const permits = permitTypes
    .filter((p) => task.permitTypeIds?.includes(p.id))
    .map((p) => p.description)
    .join(', ')

  const operationPost = operationPosts.find(
    (o) => o.id === task.operationPostId,
  )

  return (
    <>
      {task.id ? (
        <>
          {!!task.code ? (
            <BoldText>{task.code}</BoldText>
          ) : (
            <BoldText>DWS</BoldText>
          )}
          <BoldText>{task.name}</BoldText>

          <TaskPills />

          <LabelValueHeader>
            <RegularText>Task </RegularText>
            <BoldText>{`${task.sequence + 1} / ${task.jobTaskCount}`}</BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Start Date </RegularText>
            <BoldText>
              {formatDate(new Date(task.startTime)).dateShort}
            </BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Start Time </RegularText>
            <BoldText>{formatDate(new Date(task.startTime)).time}</BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Operation Post </RegularText>
            <BoldText>{operationPost?.description ?? 'None'}</BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Duration </RegularText>
            <BoldText>{task.duration} hour(s)</BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Total Crew Size </RegularText>
            <BoldText>{task.crewSize}</BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Permit Needed </RegularText>
            <BoldText>
              {getPermitResults(task.permitNeeded ?? -1)?.label}
            </BoldText>
          </LabelValueHeader>

          <LabelValueHeader>
            <RegularText>Permit Ready </RegularText>
            <BoldText>
              {getPermitResults(task.permitStatus ?? -1)?.label}
            </BoldText>
          </LabelValueHeader>

          {task.permitNeeded === 1 && (
            <LabelValueHeader>
              <RegularText>Permit Type </RegularText>
              <BoldText>{permits}</BoldText>
            </LabelValueHeader>
          )}

          <LabelValueHeader>
            <RegularText>Equipment Rental? </RegularText>
            <BoldText>{task.needsEquipmentRental ? 'YES' : 'NO'}</BoldText>
          </LabelValueHeader>

          {!task.code && (
            <LabelValueHeader>
              <RegularText>Is Break-in? </RegularText>
              <BoldText>{task.isBreakIn ? 'YES' : 'NO'}</BoldText>
            </LabelValueHeader>
          )}
        </>
      ) : (
        <BoldText>No task found</BoldText>
      )}
    </>
  )
}
